import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";

const t_prefix = "pages.aboutUs";
export default function AboutFeatures() {
  const { t } = useTranslation();
  return (
    <div className="about-description text-center">
      <div className="features-3">
        <Container>
          <Row>
            <Col className="mr-auto ml-auto" md="8">
              <h2 className="title">{t(`${t_prefix}.section1.title`)}</h2>
              <h4 className="description">
                {t(`${t_prefix}.section1.description`)}
              </h4>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <div className="info info-hover">
                <div className="icon icon-success icon-circle">
                  <i className="now-ui-icons education_glasses"></i>
                </div>
                <h4 className="info-title">
                  {t(`${t_prefix}.section1.feature1`)}
                </h4>
                <p className="description">
                  {t(`${t_prefix}.section1.feature1Description`)}
                </p>
              </div>
            </Col>
            <Col md="4">
              <div className="info info-hover">
                <div className="icon icon-info icon-circle">
                  <i className="now-ui-icons tech_watch-time"></i>
                </div>
                <h4 className="info-title">
                  {t(`${t_prefix}.section1.feature2`)}
                </h4>
                <p className="description">
                  {t(`${t_prefix}.section1.feature2Description`)}
                </p>
              </div>
            </Col>
            <Col md="4">
              <div className="info info-hover">
                <div className="icon icon-primary icon-circle">
                  <i className="now-ui-icons business_money-coins"></i>
                </div>
                <h4 className="info-title">
                  {t(`${t_prefix}.section1.feature3`)}
                </h4>
                <p className="description">
                  {t(`${t_prefix}.section1.feature3Description`)}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
